import { ComponentProps } from 'react'
import { makeStyles } from '@material-ui/core'

import { joinStyles, palette, themeMultiply, various } from 'app/utils/theme'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: various.margin,
        padding: themeMultiply(various.padding, 2),
        backgroundColor: palette.background.primary,
        borderRadius: various.borderRadius,
        boxShadow: various.boxShadow.component,
    },
})

type CardProperties = ComponentProps<'div'>

export const Card = ({
    className,
    ...properties
}: Readonly<CardProperties>): JSX.Element => {
    const classes = useStyles()

    return (
        <div
            className={joinStyles(classes.root, className)}
            {...properties}
        />
    )
}
